import { render, staticRenderFns } from "./Community.vue?vue&type=template&id=f8213fa6&"
import script from "./Community.vue?vue&type=script&lang=ts&"
export * from "./Community.vue?vue&type=script&lang=ts&"
import style0 from "./Community.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports